import { render, staticRenderFns } from "./barsLayout.vue?vue&type=template&id=60905bb6&scoped=true&"
import script from "./barsLayout.vue?vue&type=script&lang=js&"
export * from "./barsLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60905bb6",
  null
  
)

export default component.exports